import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./loaders.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import "swiper/css";
import "react-quill/dist/quill.snow.css";
import { BrowserRouter } from "react-router-dom";
// import { Auth0Provider } from "@auth0/auth0-react";

// const domain = "dev-7sj03liac3q1ttro.us.auth0.com";
// const clientId = "fQ3gGdrMyiOMLoVegg27qpHUtg02UMJJ";

// ========================================
// EXTRACT COOKIES BEFORE REACT RENDERS
// ========================================
(function initializeFromCookies() {
  // Helper to get cookie
  const getCookie = (name) => {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  };

  // Extract auth_token
  const authToken = getCookie('auth_token');
  if (authToken) {
    localStorage.setItem('auth_token', authToken);
    console.log('✅ Auth token loaded from cookie');
  }

  // Extract selectedPlan
  const selectedPlan = getCookie('selectedPlan');
  if (selectedPlan) {
    try {
      const decoded = decodeURIComponent(selectedPlan);
      localStorage.setItem('selectedPlan', decoded);
      console.log('✅ Selected plan loaded from cookie');
    } catch (e) {
      console.error('Failed to decode selectedPlan:', e);
    }
  }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: "http://localhost:3000",
      }}
    > */}
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
    {/* </Auth0Provider> */}

    <ToastContainer
      position="top-right"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      pauseOnHover
    />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
